import React, { useState, useMemo } from 'react';
import { X, Search, Check } from 'lucide-react';
import { useLang } from '../../core/lang.jsx';
import LangKeys from '../../core/locales/keys';

export const kMarketplaceCategories = [
  { id: 'General', icon: '📦', title: 'सामान्य उत्पाद', subtitle: 'General Products' },
  { id: 'grocery', icon: '🌾', title: 'किराना व राशन', subtitle: 'Grocery & Provisions' },
  { id: 'dairy', icon: '🥛', title: 'डेयरी व दूध', subtitle: 'Dairy Products' },
  { id: 'fruits_veg', icon: '🍎', title: 'फल व सब्ज़ियां', subtitle: 'Fruits & Vegetables' },
  { id: 'sweets_bakery', icon: '🍰', title: 'मिठाई व बेकरी', subtitle: 'Sweets & Bakery' },
  { id: 'restaurant_food', icon: '🍲', title: 'होटल व रेस्टोरेंट', subtitle: 'Food & Restaurant' },
  { id: 'pharmacy_medical', icon: '💊', title: 'मेडिकल व दवाई', subtitle: 'Pharmacy & Medical' },
  { id: 'agriculture_seeds', icon: '🚜', title: 'कृषि, खाद व बीज', subtitle: 'Agri & Seeds' },
  { id: 'animal_feed', icon: '🐄', title: 'पशु आहार व खल', subtitle: 'Animal Feed' },
  { id: 'electronics_mobile', icon: '📱', title: 'मोबाइल व कंप्यूटर', subtitle: 'Mobile & Computers' },
  { id: 'electrical_appliances', icon: '💡', title: 'इलेक्ट्रिकल्स', subtitle: 'Electricals' },
  { id: 'clothing_garments', icon: '👕', title: 'कपड़े व परिधान', subtitle: 'Garments & Clothing' },
  { id: 'footwear_shoes', icon: '👟', title: 'जूते व फुटवियर', subtitle: 'Footwear & Shoes' },
  { id: 'hardware_sanitary', icon: '🛠️', title: 'हार्डवेयर व टूल्स', subtitle: 'Hardware & Tools' },
  { id: 'building_materials', icon: '🧱', title: 'बिल्डिंग मैटेरियल', subtitle: 'Building Materials' },
  { id: 'automobile_parts', icon: '🛵', title: 'ऑटो पार्ट्स', subtitle: 'Automobile Spares' },
  { id: 'cosmetics_beauty', icon: '💄', title: 'कॉस्मेटिक्स व ब्यूटी', subtitle: 'Beauty & Cosmetics' },
  { id: 'stationery_books', icon: '📚', title: 'किताबें व स्टेशनरी', subtitle: 'Books & Stationery' },
  { id: 'jewellery_gifts', icon: '💍', title: 'सोना-चांदी व ज्वेलरी', subtitle: 'Jewellery & Gifts' },
  { id: 'furniture_decor', icon: '🪑', title: 'फर्नीचर व डेकोर', subtitle: 'Furniture & Decor' },
  { id: 'kitchenware_utensils', icon: '🍳', title: 'बर्तन व किचनवेयर', subtitle: 'Kitchenware' },
  { id: 'toys_sports', icon: '🧸', title: 'खिलौने व स्पोर्ट्स', subtitle: 'Toys & Sports' },
  { id: 'packaging_disposable', icon: '🧴', title: 'डिस्पोजेबल सामान', subtitle: 'Disposables & Packaging' },
  { id: 'tailoring_boutique', icon: '🪡', title: 'टेलरिंग व बुटीक', subtitle: 'Tailoring & Boutique' },
  { id: 'meat_poultry', icon: '🥩', title: 'मीट व पोल्ट्री', subtitle: 'Meat & Poultry' },
  { id: 'services_repair', icon: '🔧', title: 'रिपेयरिंग सर्विस', subtitle: 'Repair & Services' },
  { id: 'optical_eyewear', icon: '👓', title: 'चश्मा व ऑप्टिकल्स', subtitle: 'Optical & Eyewear' },
  { id: 'pooja_religious', icon: '🪔', title: 'पूजा सामग्री व अगरबत्ती', subtitle: 'Pooja Items & Essentials' },
  { id: 'watches_accessories', icon: '⌚', title: 'घड़ी व एक्सेसरीज', subtitle: 'Watches & Accessories' },
  { id: 'other', icon: '🏷️', title: 'अन्य सामान', subtitle: 'Other Products' },
];

export const kMarketplaceServiceCategories = [
  { id: 'GeneralService', icon: '🛠️', title: 'सामान्य सेवा', subtitle: 'General Service' },
  { id: 'electronics_tv_repair', icon: '📺', title: 'टीवी व इलेक्ट्रॉनिक्स', subtitle: 'TV & Electronics' },
  { id: 'ac_appliances_repair', icon: '❄️', title: 'एसी व फ्रिज रिपेयर', subtitle: 'AC & Appliance Repair' },
  { id: 'electrician_wiring', icon: '🔌', title: 'इलेक्ट्रीशियन व वायरिंग', subtitle: 'Electrician & Wiring' },
  { id: 'plumbing_sanitary', icon: '🚰', title: 'प्लंबर व फिटिंग', subtitle: 'Plumber & Sanitary' },
  { id: 'tailoring_stitching', icon: '🪡', title: 'सिलाई व टेलरिंग', subtitle: 'Tailoring & Stitching' },
  { id: 'mobile_laptop_repair', icon: '💻', title: 'मोबाइल व लैपटॉप रिपेयर', subtitle: 'Mobile & Laptop Repair' },
  { id: 'automobile_mechanic', icon: '🚗', title: 'गाड़ी मिस्त्री व सर्विस', subtitle: 'Vehicle Mechanic' },
  { id: 'beauty_parlour_salon', icon: '💇', title: 'ब्यूटी पार्लर व सैलून', subtitle: 'Beauty Parlour & Salon' },
  { id: 'carpenter_woodwork', icon: '🪚', title: 'बढ़ई व लकड़ी काम', subtitle: 'Carpenter & Woodwork' },
  { id: 'painting_whitewash', icon: '🎨', title: 'पेंटिंग व पुट्टी', subtitle: 'Painting & Whitewash' },
  { id: 'construction_civil', icon: '🏗️', title: 'मकान निर्माण व मिस्त्री', subtitle: 'Construction & Mason' },
  { id: 'agri_motor_tractor', icon: '🚜', title: 'ट्रैक्टर व मोटर सर्विस', subtitle: 'Tractor & Motor Service' },
  { id: 'cctv_security_install', icon: '🔐', title: 'सीसीटीवी कैमरा फिटिंग', subtitle: 'CCTV & Security' },
  { id: 'cleaning_pest_control', icon: '🧹', title: 'क्लीनिंग व पेस्ट कंट्रोल', subtitle: 'Cleaning & Pest Control' },
  { id: 'transport_loading', icon: '🚚', title: 'ट्रांसपोर्ट व लोडिंग', subtitle: 'Transport & Loading' },
  { id: 'photography_video', icon: '📸', title: 'फोटोग्राफी व स्टूडियो', subtitle: 'Photo & Videography' },
  { id: 'events_catering_tent', icon: '🎪', title: 'टेंट हाउस व कैटरिंग', subtitle: 'Tent & Catering' },
  { id: 'education_tuition', icon: '🎓', title: 'कोचिंग व ट्यूशन', subtitle: 'Coaching & Tuition' },
  { id: 'ca_tax_csc_emitra', icon: '⚖️', title: 'CSC, ई-मित्र व टैक्स', subtitle: 'Tax, CSC & E-Mitra' },
  { id: 'healthcare_clinic_lab', icon: '🩺', title: 'डॉक्टर, क्लिनिक व लैब', subtitle: 'Clinic & Healthcare' },
  { id: 'transport_taxi', icon: '🚖', title: 'टैक्सी व टूर ट्रैवल्स', subtitle: 'Taxi & Tour Travels' },
  { id: 'legal_advocate', icon: '⚖️', title: 'वकील व कानूनी सलाह', subtitle: 'Legal & Advocate Services' },
  { id: 'packers_movers', icon: '📦', title: 'पैकर्स एंड मूवर्स', subtitle: 'Packers & Movers' },
  { id: 'printing_flex_banner', icon: '🖨️', title: 'प्रिंटिंग व फ्लैक्स बोर्ड', subtitle: 'Printing & Flex Banner' },
  { id: 'gym_fitness_yoga', icon: '🏋️', title: 'जिम, फिटनेस व योग', subtitle: 'Gym, Fitness & Yoga' },
  { id: 'cook_maid_househelp', icon: '👩‍🍳', title: 'कुक व घरेलू सहायिका', subtitle: 'Cook & Domestic Help' },
  { id: 'other_service', icon: '🔧', title: 'अन्य सभी सेवाएं', subtitle: 'Other Services' },
];

export const getLocalizedCategory = (cat, t) => {
  if (!cat) return { id: '', icon: '📦', title: '', subtitle: '' };
  const titleKey = LangKeys[`cat_title_${cat.id.toLowerCase()}`];
  const subKey = LangKeys[`cat_sub_${cat.id.toLowerCase()}`];
  
  let locTitle = (t && titleKey && t(titleKey) && t(titleKey) !== titleKey) ? t(titleKey) : cat.title;
  let locSub = (t && subKey && t(subKey) && t(subKey) !== subKey) ? t(subKey) : cat.subtitle;
  
  return {
    ...cat,
    title: locTitle,
    subtitle: locSub
  };
};

export const getCategoryDetails = (id, isService = false, t = null) => {
  const list = isService ? kMarketplaceServiceCategories : kMarketplaceCategories;
  const defaultItem = isService ? kMarketplaceServiceCategories[0] : kMarketplaceCategories[0];
  if (!id) return t ? getLocalizedCategory(defaultItem, t) : defaultItem;
  
  const found = list.find(
    c => c.id.toLowerCase() === String(id).toLowerCase() || 
         c.title.toLowerCase() === String(id).toLowerCase() || 
         c.subtitle.toLowerCase() === String(id).toLowerCase()
  ) || defaultItem;

  return t ? getLocalizedCategory(found, t) : found;
};

const CategoryPickerModal = ({ isOpen, onClose, selectedId, onSelect, isService = false }) => {
  const { t } = useLang();
  const [query, setQuery] = useState('');

  const localizedList = useMemo(() => {
    const rawList = isService ? kMarketplaceServiceCategories : kMarketplaceCategories;
    return rawList.map(c => getLocalizedCategory(c, t));
  }, [isService, t]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return localizedList;
    return localizedList.filter(c => 
      c.id.toLowerCase().includes(q) ||
      c.title.toLowerCase().includes(q) ||
      c.subtitle.toLowerCase().includes(q)
    );
  }, [localizedList, query]);

  if (!isOpen) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={styles.header}>
          <div>
            <h3 style={styles.title}>{t(LangKeys.category_picker_title) || 'Select Category'}</h3>
            <p style={styles.subtitle}>
              {isService 
                ? (t(LangKeys.category_picker_sub_service) || 'Choose the best category for this service')
                : (t(LangKeys.category_picker_sub_item) || 'Choose the best category for this product')}
            </p>
          </div>
          <button style={styles.closeBtn} onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        {/* Search */}
        <div style={styles.searchWrap}>
          <Search size={18} color="#94A3B8" />
          <input
            style={styles.searchInput}
            placeholder={t(LangKeys.category_search_hint) || 'Search category...'}
            value={query}
            onChange={e => setQuery(e.target.value)}
            autoFocus
          />
          {query && (
            <button style={styles.clearBtn} onClick={() => setQuery('')}>
              <X size={14} />
            </button>
          )}
        </div>

        {/* Categories List */}
        <div style={styles.list}>
          {filtered.length === 0 ? (
            <div style={styles.noResults}>
              {t(LangKeys.no_category_found) || 'No categories found'}
            </div>
          ) : (
            filtered.map(cat => {
              const isSelected = String(selectedId).toLowerCase() === cat.id.toLowerCase();
              return (
                <div
                  key={cat.id}
                  style={{
                    ...styles.catCard,
                    ...(isSelected ? styles.catCardSelected : {})
                  }}
                  onClick={() => {
                    onSelect(cat.id);
                    onClose();
                  }}
                >
                  <div style={styles.catIconWrap}>{cat.icon}</div>
                  <div style={styles.catTextWrap}>
                    <div style={styles.catTitle}>{cat.title}</div>
                    <div style={styles.catSub}>{cat.subtitle}</div>
                  </div>
                  {isSelected && (
                    <div style={styles.checkBadge}>
                      <Check size={16} color="#FFF" />
                    </div>
                  )}
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(15, 23, 42, 0.6)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 3000,
    padding: '16px'
  },
  modal: {
    width: '100%',
    maxWidth: '520px',
    maxHeight: '85vh',
    backgroundColor: '#FFF',
    borderRadius: '24px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  },
  header: {
    padding: '20px 24px',
    borderBottom: '1px solid #F1F5F9',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#FAFAFA'
  },
  title: {
    fontSize: '18px',
    fontWeight: '800',
    color: '#0F172A',
    margin: 0
  },
  subtitle: {
    fontSize: '12px',
    color: '#64748B',
    margin: '4px 0 0 0'
  },
  closeBtn: {
    border: 'none',
    backgroundColor: '#F1F5F9',
    color: '#64748B',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  searchWrap: {
    margin: '16px 20px 8px 20px',
    padding: '10px 14px',
    backgroundColor: '#F1F5F9',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  searchInput: {
    flex: 1,
    border: 'none',
    background: 'transparent',
    outline: 'none',
    fontSize: '14px',
    color: '#0F172A',
    fontWeight: '500'
  },
  clearBtn: {
    border: 'none',
    backgroundColor: '#CBD5E1',
    color: '#475569',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  list: {
    padding: '12px 20px 20px 20px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  catCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    padding: '12px 16px',
    borderRadius: '14px',
    backgroundColor: '#F8FAFC',
    border: '1px solid #E2E8F0',
    cursor: 'pointer',
    transition: 'all 0.15s ease'
  },
  catCardSelected: {
    backgroundColor: '#EFF6FF',
    borderColor: '#3B82F6',
    boxShadow: '0 2px 8px rgba(59, 130, 246, 0.15)'
  },
  catIconWrap: {
    fontSize: '24px',
    width: '42px',
    height: '42px',
    borderRadius: '10px',
    backgroundColor: '#FFF',
    border: '1px solid #E2E8F0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  catTextWrap: {
    flex: 1
  },
  catTitle: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#0F172A'
  },
  catSub: {
    fontSize: '12px',
    color: '#64748B',
    marginTop: '2px'
  },
  checkBadge: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: '#3B82F6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  noResults: {
    textAlign: 'center',
    padding: '40px 20px',
    color: '#94A3B8',
    fontSize: '14px'
  }
};

export default CategoryPickerModal;
